<template>
  <v-dialog v-model="dialog"
            width="500">
    <template v-slot:activator="{ on }">
      <v-btn color="primary"
             v-on="on"
             block>
        Valider l'inscription
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="headline primary white--text"
                    primary-title>
        Valider l'inscription
      </v-card-title>

      <v-card-text class="pt-5">
        <p>Élève inscrit le {{mission.patient.created_at | moment('L à LT')}}</p>
        <IriadeDoctorSelect :default-doctor-id="mission.patient.doctor_id"
                            v-model="doctor_id"></IriadeDoctorSelect>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn text
               @click="dialog = false">Annuler
        </v-btn>
        <v-btn color="primary"
               text
               :loading="loading"
               @click="submit">
          Valider
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import api from 'api'
  import IriadeDoctorSelect from 'components/Screens/Doctor/CreatePatient/components/IriadeDoctorSelect'

  export default {
    components: {
      IriadeDoctorSelect
    },

    data () {
      return {
        dialog: false,
        loading: false,
        doctor_id: null
      }
    },

    methods: {
      submit () {
        this.loading = true
        api.post(`doctors/missions/${this.mission.id}`, {doctor_id: this.doctor_id})
          .then(res => {
            this.dialog = false
            this.loading = false
            this.$mango.snackbar({
              color: 'success',
              text: "Mission validée. Bravo !"
            })
          })
        this.$emit('finished')
      }
    },

    props: {
      mission: {
        required: true,
        type: Object
      }
    }
  }
</script>
